import { render } from "./MobileLayout.vue?vue&type=template&id=0a76b070"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/MobileLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a76b070"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a76b070', __exports__)) {
    console.log('reload')
    api.reload('0a76b070', __exports__)
  }
  
  module.hot.accept("./MobileLayout.vue?vue&type=template&id=0a76b070", () => {
    console.log('re-render')
    api.rerender('0a76b070', render)
  })

}


export default __exports__